<template>
  <div class="wg-row">
    <div class="wg-col wg-xs-12 wg-sm-12">
      <div class="com-anm22-app-text-m">{{$anm22.strLang(lang, 'Customers', 'Contatti progetto ') }}</div>
      <div class="vertical-height-div" style="height:5px;"></div>
      <select class="com-anm22-app-select" v-model="contactRef">
        <option value="0">Nessun contatto selezionato</option>
        <option
          v-for="(customer,index) in customersToAdd"
          :key="'customer-'+index"
          :value="customer.idContactsContact"
        >
          <span>{{customer.firstName + ' ' + customer.lastName }}</span>
        </option>
      </select>
    </div>
    <div class="vertical-height-div" style="height:15px;"></div>
    <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
    <input
      type="button"
      :style="{opacity : !canImport ? '0.7' : ''}"
      :disabled="!canImport"
      :value="$anm22.strLang(lang, 'Import ', 'Importa')"
      @click="importFeed"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [String, Number],
    msg: Object
  },
  data() {
    return {
      contactRef: 0
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    boardFeedAssoc() {
      return this.$store.getters["feedBoardAssocs/getByBoardMessage"](
        this.msg.idWorldMessage
      );
    },
    customers() {
      return this.project.customers
        .map(c => this.$store.getters["contacts/get"](c))
        .filter(c => c);
    },
    //Customers ancora disponibili per l'importazione
    customersToAdd() {
      let result = [];
      this.customers.forEach(c => {
        let associated = false;
        this.boardFeedAssoc.forEach(assoc => {
          if (c.idContactsContact == assoc.contact) {
            associated = true;
          }
        });
        if (!associated) {
          result.push(c);
        }
      });
      return result;
    },
    canImport() {
      if (this.contactRef == 0) {
        return false;
      }
      return true;
    }
  },
  methods: {
    importFeed() {
      this.loadImport = true;
      this.$http
        .post("project/import", {
          contactId: this.contactRef,
          msg: this.msg,
          projectId: this.project.idWorldProject
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch("feedBoardAssocs/update", {
              vlf: this.$vlf("feedBoardAssocs"),
              objs: [response.data.assoc]
            }),
            this.$store.dispatch("messages/update", {
              vlf: this.$vlf("messages"),
              objs: [response.data.msgFeed]
            })
          ]);
          this.$Progress.finish();
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
